import { render, staticRenderFns } from "./ClassTabs.vue?vue&type=template&id=60015c98"
import script from "./ClassTabs.vue?vue&type=script&lang=js"
export * from "./ClassTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports